import React, { Fragment } from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';
import useIframePostMessage, { Message } from 'hooks/useIframePostMessage';

const Home: React.FC = () => {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  const [message, setMessage] = React.useState<Message>(null);
  const { iframeRef } = useIframePostMessage({ message });

  React.useEffect(() => {
    const buildMessage = async () => {
      const isPrimaryUser = await window.lsCloud.Config.access('is_primary_user');
      const modulesList: ModuleName[] = ['settings.employees.limit_to_multiple_shops'];
      const modules = modulesList.filter(module => window.lsCloud.Modules.hasModule(module));
      setMessage({
        type: 'retailEmployee',
        payload: { isPrimaryUser, modules },
      });
    };

    buildMessage();

    window.merchantos?.asyncSubscribe?.notifySubscribers('react.mount.topbar', {
      props: {
        crumbs: [
          {
            text: 'Home',
            name: 'home',
          },
        ],
      },
    });
  }, []);

  return (
    <Fragment>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `.react-page { height: 100% }`,
        }}
      />
      <iframe
        src={`/webapps_redirect.php?app=retail-home&next=${encodeURIComponent(
          `/${window.location.search}`
        )}`}
        title="home page"
        style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        ref={iframeRef}
      />
    </Fragment>
  );
};

export default withLocalizeAwareIframe(withValidSessionIframe(Home));
